import { makeStyles } from 'tss-react/mui';
import React from 'react';
import clsx from 'clsx';
import { IFormFieldInputBaseProps } from '@components/form-fields';
import { MAIN_THEME } from '@styles';

const useStyles = makeStyles()(() => ({
  separator: {
    background: `${MAIN_THEME.color.white98} 0% 0% no-repeat padding-box`,
    height: 10,
    width: '100%',
    margin: '10px 0',
  },
}));

const Separator: React.FC<IFormFieldInputBaseProps> = ({
  className,
  style,
}) => {
  const { classes } = useStyles();

  return <div className={clsx(classes.separator, className)} style={style} />;
};

export default Separator;
